import * as React from "react";
function SvgTagAuto(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M14.96 31H4.1L2.04 20.57 17.04 2l12.91 10.43-2.01 2.5"
      />
      <path d="M9.83 22.5a1 1 0 11-1 1 1 1 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3z" />
      <path
        d="M26.93 19.4a6 6 0 11-4.8.46"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M22.7 23.49v-4.5h-4.51"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTagAuto);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
